import React from "react";
import { MapPin, Smartphone, CheckCircle2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

const STEP_ICONS = [MapPin, Smartphone, CheckCircle2];

export default function HowItWorks() {
  const { t } = useLang();
  return (
    <section id="how" className="section-y bg-white" data-testid="how-section">
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="overline">{t.how.overline}</span>
          <h2 className="mt-5 text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight text-brand-ink text-balance">
            {t.how.title}
          </h2>
        </div>

        <div className="mt-14 relative grid md:grid-cols-3 gap-6 md:gap-8">
          {/* Connecting hairline */}
          <div aria-hidden className="hidden md:block absolute left-12 right-12 top-14 h-px bg-gradient-to-r from-transparent via-brand-mist to-transparent" />
          {t.how.steps.map((s, i) => {
            const Icon = STEP_ICONS[i];
            return (
              <div
                key={s.n}
                className="relative card-soft card-soft-hover p-7 md:p-8"
                data-testid={`how-step-${i}`}
              >
                <div className="flex items-center justify-between">
                  <span className="grid place-items-center h-12 w-12 rounded-2xl bg-brand-ink text-white">
                    <Icon className="h-5 w-5" />
                  </span>
                  <span className="font-heading text-sm font-semibold tracking-[0.2em] text-brand-champagne">
                    {s.n}
                  </span>
                </div>
                <h3 className="mt-6 text-xl md:text-2xl font-medium text-brand-ink tracking-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-brand-graphite leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
